import { formatDistanceToNowStrict } from "date-fns";
import type { ContextPackRequest } from "./types";

export function timeAgo(value?: string | null) {
  if (!value) return "never";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "unknown";
  return formatDistanceToNowStrict(date, { addSuffix: true });
}

export function safeExternalUrl(value?: string | null) {
  if (!value) return undefined;
  try {
    const parsed = new URL(value);
    return parsed.protocol === "http:" || parsed.protocol === "https:" ? parsed.toString() : undefined;
  } catch {
    return undefined;
  }
}

export function formatNumber(value = 0) {
  return new Intl.NumberFormat("en", { notation: value > 9999 ? "compact" : "standard" }).format(value);
}

export function formatTokens(value = 0) {
  if (value < 1000) return `${value}`;
  if (value < 1_000_000) return `${(value / 1000).toFixed(value >= 100_000 ? 0 : 1)}k`;
  if (value < 1_000_000_000) return `${(value / 1_000_000).toFixed(value >= 100_000_000 ? 0 : 1)}M`;
  return `${(value / 1_000_000_000).toFixed(value >= 100_000_000_000 ? 0 : 1)}B`;
}

export function contextPackRequestNeedsReview(request: ContextPackRequest) {
  return request.status === "pending"
    || ((request.status === "approved" || request.status === "rejected") && !request.reviewedAt);
}

export function initials(value: string) {
  return value
    .split(/\s+/)
    .map((word) => word[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();
}

export function cx(...values: Array<string | false | null | undefined>) {
  return values.filter(Boolean).join(" ");
}

export function nodeId(value: string | { id: string }) {
  return typeof value === "string" ? value : value.id;
}
